import Head from "next/head";

import ReviewBoardFlow from "../../components/ReviewBoardFlow";

import { useRouter } from "next/router";
import { useAppSelector } from "../../utils/hooks/store";
import { BoardHeader } from "../../components/Header/BoardHeader";
import { AuthContainerProps, FlashPCBPage } from "../../models/page";
import { useCallback, useEffect } from "react";
import Modal from "../../components/common/Modal";
import * as styledElements from "../../components/ReviewBoardFlow/ReviewBoardFlowStyles";
import { DEMO_BOARD_SLUG } from "../../constants/boards";
import { BoardIdContext } from "../../utils/hooks/commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";

const ReviewBoardPage: FlashPCBPage = () => {
  const router = useRouter();
  const boardId = router.query.boardId as string;
  const shipmentId = (router.query.shipmentId as string | undefined) || null;
  const projectName = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.board?.project_name,
  );
  const view = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.view || null,
  );

  useEffect(() => {
    if (view !== null && router.query.view !== view) {
      const newPath = {
        pathname: router.pathname,
        query: {
          ...router.query,
          view: view,
        },
      };
      void router.replace(newPath, undefined, { scroll: false });
    }
  }, [router, view]);

  const setShipmentId = useCallback(
    (newShipmentId: string) => {
      const newPath = {
        pathname: router.pathname,
        query: {
          ...router.query,
          shipmentId: newShipmentId,
        },
      };
      void router.replace(newPath, undefined, { scroll: false });
    },
    [router],
  );

  return (
    <>
      <Head>
        <title>{`Your board${projectName ? `: ${projectName}` : ""}`}</title>
        <meta
          name="description"
          content="Previews, the bill of materials, and the quote for your board"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <BoardIdContext.Provider value={{ boardId, shipmentId, setShipmentId }}>
        <ReviewBoardFlow />
      </BoardIdContext.Provider>
    </>
  );
};

ReviewBoardPage.Header = BoardHeader;

function ReviewBoardAuthContainer({ children }: AuthContainerProps) {
  return (
    <Modal isOpen={true}>
      <styledElements.SignInContainer>
        <div>Please sign in or create an account to continue to your board</div>
        {children}
      </styledElements.SignInContainer>
    </Modal>
  );
}

ReviewBoardPage.authOptions = {
  AuthContainer: ReviewBoardAuthContainer,
  allowUnauthenticatedIf: (router) => {
    return router.query.boardId == DEMO_BOARD_SLUG;
  },
  defaultAuthMode: "Sign Up",
};

export default ReviewBoardPage;
